import { AuthApi, Configuration, UsersApi } from "../generated";

const readApiBaseFromEnv = (): string => {
  // Get API base URL from env
  // Priority is given to same host in the browser when environemnt is production
  if (
    process.env.NODE_ENV === "production" &&
    !document.location.host.startsWith("localhost")
  ) {
    return `https://${document.location.host}`;
  } else if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }
  return "http://127.0.0.1:8100";
};

const readAccessToken = async (): Promise<string> => {
  return localStorage.getItem("accessToken") || "";
};

const readRefreshToken = async (): Promise<string> => {
  return localStorage.getItem("refreshToken") || "";
};

export const basePath: string = readApiBaseFromEnv();

const apiConfig: Configuration = new Configuration({
  basePath,
  accessToken: readAccessToken,
});

const apiRefreshConfig: Configuration = new Configuration({
  basePath,
  accessToken: readRefreshToken,
});

export const authApi: AuthApi = new AuthApi(apiConfig);
export const authRefreshApi: AuthApi = new AuthApi(apiRefreshConfig);
export const userApi: UsersApi = new UsersApi(apiConfig);
